<template>
  <router-link class="btn-back" :to="route">
    <ion-icon name="chevron-back-outline"/>
    Voltar
  </router-link>
</template>

<script>
export default {
  name: "btnBack",
  props: {
    route: {
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>

.btn-back {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 6px 18px;
  border: 1px solid #2F23D6;
  border-radius: 4px !important;
  font-size: 14px;
  font-weight: 500;
  color: #2F23D6;
  cursor: pointer;
  transition: .2s;
  text-decoration: none;

  &:hover {
    color: #FFFFFF;
    background: #2F23D6;
  }

  ion-icon {
    font-size: 20px;
  }
}

</style>



// WEBPACK FOOTER //
// src/vue/pages/components/buttons/btnBack.vue